// import Glide from '@glidejs/glide'
import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm';

const onChange = (objToWatch, onChangeFunction) => {
    const handler = {
        set(target, property, value, receiver) {
            if (property === 'index') onChangeFunction();
            return Reflect.set(target, property, value);
        }
    };
    return new Proxy(objToWatch, handler);
}

const galerias = document.querySelectorAll('.galeria-cb');
let gals = [];

Object.values(galerias).map((galeria, idx) => {
    galeria.setAttribute(`data-idx`,idx)

    // Slides
    const ul = galeria.querySelector('.glide__slides');
    let cLi = 0;
    for (let i = 0; i < ul.childNodes.length; i++)
    if (ul.childNodes[i].nodeName === 'LI')
    cLi++;

    //  Bullets
    let controlsDiv = galeria.querySelector('.glide__bullets');
    let buttonsHtml = ``;
    for (let i = 0; i < cLi; i++) {
        buttonsHtml += `<button class="glide__bullet" aria-label="Slide ${i}" data-glide-dir="=${i}" data-idx="${i}"></button>`;
    }            
    controlsDiv.innerHTML = buttonsHtml;

    // Init Gallerys
    const glide = new Glide(galeria, {
        gap: 20,
        startAt: 0,
    });
    const proxyGlide = onChange(glide, () => {
        const urlArray = (document.URL).split('/').filter(x => x !== '');

        const materia  = '/'.concat(
            urlArray[urlArray.length - 1],
            '?galeria=1',
        );

        ga('send', 'pageview', materia);
    });
    gals[`${idx}`] = proxyGlide
    proxyGlide.mount({ Controls, Breakpoints, Swipe });
});

// Update Bullets
let itemBullets = document.querySelectorAll('.glide__bullets')
itemBullets.forEach((element, indexGal) => {
    element.childNodes.forEach((item, indexBullet) => {
        item.addEventListener('click', function (e) {
            gals[indexGal].update({ startAt: indexBullet })
            console.log(gals[indexGal])
            console.log(indexBullet)
        })
    })
});

// console.log(clkBulletUpdt[1].parentElement.dataset.idx)

// clkBulletUpdt.forEach((item, indexGal) => {
//     item.addEventListener('click', function (e) {
//         gals[indexGal].update({ startAt: 1 })
//         console.log()
//     })

//     // let ctrl = 0, galeriaAnterior = ''
//     // if(clkResult != galeriaAnterior ){
//     //     ctrl = 0
//     // }
//     // item.addEventListener('click', function (e) {
//     //     // console.log(`Index do bullet: ${e.target.dataset.idx} `)
//     //     const clkResult = e.target.parentElement.parentElement.dataset.idx

//     //     gals[clkResult].update({ startAt: ctrl })
//     //     console.log(ctrl)
//     // })
//     // ctrl++
//     // galeriaAnterior = clkResult
// })

// galerias.forEach((item, index) => {

    // const ul = item.querySelector('.glide__slides');
    // let cLi = 0;
    // for (let i = 0; i < ul.childNodes.length; i++)
    //     if (ul.childNodes[i].nodeName === 'LI')
    //         cLi++;

    // let controlsDiv = item.querySelector('.glide__bullets');

    // let buttonsHtml = ``;
    // for (let i = 1; i <= cLi; i++) {

    //     buttonsHtml += `<button class="glide__bullet" data-glide-dir="=${i}"></button>`;
    // }
    // controlsDiv.innerHTML = buttonsHtml;
//     glide.update()

// });





// var glide = new Glide('.glide', {
//     type: 'carousel',
//     focusAt: 'center',
//     perView: 1
// })

// select.addEventListener('change', function (event) {
//     glide.update({
//         type: event.target.value
//     })
// })

// glide.mount()

// import Siema from 'siema';

// const varGal = document.querySelector('.siema');

// new Siema({
//     selector: varGal,
//     duration: 200,
//     easing: 'ease-out',
//     perPage: 1,
//     startIndex: 0,
//     draggable: true,
//     multipleDrag: true,
//     threshold: 20,
//     loop: false,
//     rtl: false,
//     onInit: () => {},
//     onChange: () => {},
// });



// if (document.querySelector('.galeria-cb')) {
//     // let gals = {}
//     // let idx = 1

//     // Add a function that generates pagination to prototype
//     // Siema.prototype.addPagination = function () {
//     //     // Criar uma div relacionar dentro dela a paginação

//     //     const div = document.createElement('div');
//     //     div.classList.add('pagination');
//     //     for (let i = 0; i < this.innerElements.length; i++) {
//     //         let btn = document.createElement('button');
//     //         btn.textContent = '•';

//     //         if(i === 0)
//     //             btn.setAttribute('style', 'color: #53c3ff');

//     //         div.appendChild(btn);
//     //     }

//     //     for(let i = 0; i < div.children.length; i++){
//     //         div.children[i].onclick = () => {
//     //             const previousSlide = this.currentSlide;

//     //             this.goTo(i);
//     //             const { currentSlide } = this;

//     //             div.children[previousSlide].removeAttribute('style');
//     //             div.children[currentSlide].setAttribute('style', 'color: #53c3ff');
//     //         }
//     //     }

//     //     this.selector.appendChild(div);
//     // }

//     // function syncBtnFullscreen(elem, idx) {
//     //     const { currentSlide } = gals[idx];
//     //     const pagination = elem.children[1];

//     //     for(let i = 0; i < pagination.children.length; i++){
//     //         if(i === currentSlide){
//     //             pagination.children[i].setAttribute('style', 'color: #53c3ff');
//     //         } else {
//     //             pagination.children[i].removeAttribute('style');
//     //         }
//     //     }
//     // }

//     // Fullscreen
//     // function toggleFullscreen(e) {
//     //     isShowingFullScreen(e) ? hideFullScreen(e) : showFullScreen(e)
//     // }

//     // function isShowingFullScreen(e) {
//     //     return e.classList.contains('fullscreen');
//     // }

//     // function hideFullScreen(e) {
//     //     const elem = e.children[0];
//     //     const idx = elem.getAttribute('idx');

//     //     e.classList.remove('fullscreen')
//     //     document.querySelector('body').classList.remove('block-screen')
//     //     gals[e.children[0].getAttribute(`idx`)].resizeHandler()
//     //     gals[e.children[0].getAttribute(`idx`)].addPagination()

//     //     syncBtnFullscreen(elem, idx);

//     //     e.children[1].children[0].setAttribute('style', 'display: inherit');
//     //     e.children[1].children[1].setAttribute('style', 'display: none');

//     //     let maxHeight = generateHeight(elem);
//     //     e.children[0].children[1].setAttribute('style', `bottom: ${maxHeight + 50}px`);
//     // }

//     // function showFullScreen(e) {
//     //     const elem = e.children[0];
//     //     const idx = elem.getAttribute('idx');

//     //     e.classList.add('fullscreen')
//     //     document.querySelector('body').classList.add('block-screen')
//     //     gals[e.children[0].getAttribute(`idx`)].resizeHandler()
//     //     gals[e.children[0].getAttribute(`idx`)].addPagination()

//     //     syncBtnFullscreen(elem, idx);

//     //     e.children[1].children[1].setAttribute('style', 'display: inherit; width: 20px; height: 20px');
//     //     e.children[1].children[0].setAttribute('style', 'display: none');

//     //     let maxHeight = generateHeight(elem);
//     //     e.children[0].children[1].setAttribute('style', `bottom: ${maxHeight + 30}px`);
//     // }

//     // function colorBtn(prev, current, btns) {
//     //     const pagination = btns;
//     //     pagination.children[prev].removeAttribute('style');
//     //     pagination.children[current].setAttribute('style', 'color: #53c3ff');
//     // }

//     // function generateHeight(galeria) {
//     //     const slides = galeria.children[0];

//     //     let maxHeight = 0;
//     //     for(let i = 1; i < slides.children.length - 1; i++){
//     //         if(slides.children[i].children[0].children[1]){
//     //             let height = slides.children[i].children[0].children[1].offsetHeight;

//     //             if(height > maxHeight)
//     //                 maxHeight = height;
//     //         }
//     //     }

//     //     return maxHeight;
//     // }

    // const galerias = document.querySelectorAll('.galeria-cb');
    // galerias.forEach((galeria) => {
    //     // galeria.setAttribute(`idx`,idx)

    //     // Init
    //     let instance = new Siema({
    //         selector: galeria,
    //         duration: 200,
    //         easing: 'ease-out',
    //         perPage: 1,
    //         startIndex: 0,
    //         draggable: true,
    //         multipleDrag: true,
    //         // threshold: 20,
    //         // loop: true,
    //         // rtl: false,
    //         // onInit: () => {},
    //         // onChange: () => {},
    //     });
    //     // instance.addPagination()
    //     // gals[`${idx}`] = instance
    //     // idx++
    // })

//     // Map '.wrap-gal' elements
//     // const wrapGal = document.querySelectorAll('.wrap-gal')

//     // wrapGal.forEach((item) => {

//     //     // Add Function Fullscreen
//     //     item.children[1].addEventListener('click', function(e) {
//     //         toggleFullscreen(item)
//     //     })

//     //     // Add a Button Next and Previous
//     //     const prev = item.querySelector('.prev');
//     //     const next = item.querySelector('.next');

//     //     prev.addEventListener('click', () => {
//     //         const idx = item.children[0].getAttribute('idx');

//     //         const previousSlide = gals[idx].currentSlide;
//     //         gals[idx].prev();
//     //         const { currentSlide } = gals[idx];

//     //         colorBtn(previousSlide, currentSlide, gals[idx].selector.children[1]);
//     //     });
//     //     next.addEventListener('click', () => {
//     //         const idx = item.children[0].getAttribute('idx');

//     //         const previousSlide = gals[idx].currentSlide;
//     //         gals[idx].next();
//     //         const { currentSlide } = gals[idx];

//     //         colorBtn(previousSlide, currentSlide, gals[idx].selector.children[1]);
//     //     });

//     // })

//     // galerias.forEach(galeria => {
//     //     let maxHeight = generateHeight(galeria);

//     //     galeria.children[1].setAttribute('style', `bottom: ${maxHeight + 30}px;`);
//     // })
// }